import { DefaultComponentProps, MouseEventModifiers } from '../../types';

import { TableOfContentRoot } from './TableOfContent.styled';
import TableOfContentMenuGroup from './TableOfContentMenuGroup';
import type { TableOfContentConfigItem } from './types';

export type TableOfContentProps = DefaultComponentProps & {
  activeItemId: string;
  items: TableOfContentConfigItem[];

  /** This will be invoked only for menu items without children */
  onSubItemClick: (id: string, event: MouseEventModifiers) => void;
};

const TableOfContent: React.FC<TableOfContentProps> = ({
  activeItemId,
  items,
  onSubItemClick,
  'data-testid': dataTestId = 'table-of-content',
  ...rest
}) => (
  <TableOfContentRoot data-testid={dataTestId} {...rest}>
    {items
      .filter(item => !item.isHidden)
      .map(groupItem => (
        <TableOfContentMenuGroup
          activeItemId={activeItemId}
          group={groupItem}
          key={groupItem.id}
          onSubItemClick={onSubItemClick}
        />
      ))}
  </TableOfContentRoot>
);

export default TableOfContent;
